<template>
  <div>
    <van-empty description="Size özel bildirim yok" />

  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  created (){
    this.$store.commit("setLoading",[false,'...']);
  },
  methods: {

  },
};
</script>



// WEBPACK FOOTER //
// src/views/home.vue